/**
 * @generated SignedSource<<5cbc980d29662128a0199d786867e572>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRemoveNegotiationTest_item">;
  readonly " $fragmentType": "PdpRespDealerChatLoader_item";
};
export type PdpRespDealerChatLoader_item$key = {
  readonly " $data"?: PdpRespDealerChatLoader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerChatLoader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerChatLoader_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRemoveNegotiationTest_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "20cdaf8668f3c5f5ab334a570ccb2c33";

export default node;
